"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalReferenceMarkdownDirectiveDefinition = void 0;
exports.formatSignalReferenceDirective = formatSignalReferenceDirective;
const MarkdownDirectiveDefinition_1 = require("./MarkdownDirectiveDefinition");
exports.SignalReferenceMarkdownDirectiveDefinition = Object.freeze({
    allowedAttributes: ['signalName'],
    contentAttributeName: 'signalName',
    directive: 'signal',
    nodeTypes: [MarkdownDirectiveDefinition_1.NodeTypes.TextDirective],
});
function formatSignalReferenceDirective(signalName) {
    return `:${exports.SignalReferenceMarkdownDirectiveDefinition.directive}[${(0, MarkdownDirectiveDefinition_1.escapeDirectiveContent)(signalName)}]`;
}
//# sourceMappingURL=SignalReference.js.map